// src/ui/preview-banner.tsx — P5 D-16 preview-mode indicator.
//
// Self-healing per Pitfall 9: gates on isPreviewMode() (URL query + sessionStorage),
// so a stray ?preview=draft URL without a draft does NOT falsely activate the banner.
// The component self-returns null when not in preview mode, so mounting it
// unconditionally at App top-level is safe and the preferred pattern
// (UI-SPEC: "non-dismissable non-transient" — visible from loading through game).
//
// Accessibility: role="status" + aria-live="polite" so screen readers announce
// "Preview mode" once on load. Non-dismissable by design — removing the banner
// requires closing the tab (sessionStorage is cleared on tab close by the browser).
//
// Source: .planning/phases/05-content-pipeline-characters-admin-cms/05-UI-SPEC.md
//         §Preview-Mode Banner.

import type { JSX } from 'react';

import { isPreviewMode } from './preview-mode';
import './preview-banner.css';

export function PreviewBanner(): JSX.Element | null {
  if (!isPreviewMode()) return null;
  return (
    <div
      className="preview-banner"
      role="status"
      aria-live="polite"
      data-testid="preview-banner"
    >
      <span className="preview-banner__word">PREVIEW</span>
      <span className="preview-banner__rest"> MODE — close tab to exit</span>
    </div>
  );
}
